import {z as zod} from "zod";

export type ReportCollectionWorkspaceCapabilityConfiguration = Record<string, never>;

export const reportCollectionWorkspaceCapabilityConfigurationValidator: zod.ZodType<ReportCollectionWorkspaceCapabilityConfiguration> = zod.strictObject({});
